import { Action } from "redux";

export const RELOAD_CHANGES = "RELOAD_CHANGES";

export const reloadChangesAction = (): Action => {
    return {
        type: RELOAD_CHANGES,
    };
};
